import { isDevelopment } from "./EnvHelper";

export const dataLayerPush = async (eventName?: string, newData?: any) => {
  if (!isDevelopment) {
    window.dataLayer.push({ event: eventName, data: newData });
  }
  return;
};
